import pubsub from "@viewlift/pubsub";
import { VideoAnalyticsProviderWrapper } from "./adoblePlayerHelpers";
import { APP_MEASUREMENT, VISITOR } from "./Configuration";

var Media
var MediaConfig

function containsUsaNetwork() {
  return window?.location?.href?.toLowerCase()?.includes("usanetwork");
}

export function setupMediaHeartbeat(M,mC) {
  Media = M
  MediaConfig = mC
setTimeout(() => { 
  if (window != undefined && window.AppMeasurement != undefined && window.Visitor != undefined) {
    // app measurement setup
    var visitor = window.Visitor.getInstance(VISITOR.MARKETING_CLOUD_ORG_ID);
    visitor.trackingServer = containsUsaNetwork() ? VISITOR.ANALYTICS_TRACKING_SERVER : VISITOR.TRACKING_SERVER;
    const appMeasurement = new window.AppMeasurement(APP_MEASUREMENT.RSID);
    appMeasurement.visitor = visitor;
    appMeasurement.trackingServer = containsUsaNetwork() ? VISITOR.ANALYTICS_TRACKING_SERVER : VISITOR.TRACKING_SERVER;


    var mediaConfig = new MediaConfig();
    mediaConfig.trackingServer = VISITOR.TRACKING_SERVER;
    mediaConfig.playerName = `Viewlift Player`;
    mediaConfig.channel = "On-Domain"
    mediaConfig.debugLogging = false;
    mediaConfig.appVersion = window?.ADB?.Media?.version;
    mediaConfig.ssl = true;

    Media.configure(mediaConfig, appMeasurement); // combining Media SDK with App Measurement
    window.adobeConfigurationLoaded = true;
    pubsub.publish('adobeConfigurationLoaded',true)
  }
  },500) // wait for 500ms to ensure the Media SDK is loaded
}

export const attachAdobePlayerEvents = (playerInstance, entitlementData) => {
  // loads when configuration is ready
  try {
    new VideoAnalyticsProviderWrapper(playerInstance, Media, entitlementData)
  }
  catch (err) {
    console.log(err)
  }
}